import React from "react";

export default function SUM() {
  return <div>Excel_SUM</div>;
}
